<script>
import { eventHub } from '@/services/eventhub';

export default {
	props: {
		extraCssClass: {
			type: String,
			default: '',
		},
		filterKey: {
			type: String,
			default: null,
		},
		filterValues: {
			type: Array,
			default: () => [],
		},
	},
	beforeCreate() {
		eventHub.$on('removingFilterValue', (eventData) => {
			if (this.filterKey && eventData.filterKey === this.filterKey) {
				let filter = this.getFilterValueByValue(eventData.filter.value);
				if (filter) {
					filter.IsSelected = false;
					if (typeof this.userValue === 'string') {
						this.userValue = 0;
					}
				} else {
					console.log("Couldn't find by value", eventData.filter, this.filterValues);
				}
				this.updateValues();
			}
		});
	},
	methods: {
		getSelectedValues() {
			return this.filterValues
				.filter((fV) => fV.IsSelected)
				.map((fV) => fV.Value)
				.join(',');
		},
		getFilterValueByValue(value) {
			return this.filterValues.find((fV) => fV.Value == value);
		},
	},
};
</script>
